import React from "react";
import { motion } from "framer-motion";

import HeroSection from "../customComponent/HeroSection";
import MarketingLanding from "../customComponent/MarketingLanding";
import OurServices from "../customComponent/OurServices";
import WhyUs from "../customComponent/WhyUs";
import GrowthPartner from "../customComponent/GrowthPartner";
import aboutPageData from "../config/aboutPage";
import CustomContainer from "../customComponent/Container/CustomContainer";
import SectionHeadingTitle from "../customComponent/Title/SectionHeadingTitle";
import CustomParagraph from "../customComponent/Title/CustomParagraph";
import CardWithImageOrTitle from "../customComponent/Card/CardWithImageOrTitle";

// Updated variant key names
const fadeUpVariant = {
  fadeUp: { opacity: 0, y: 40 },
  inView: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1], // Smooth bezier curve
    },
  },
};


const HomePage = () => {
  return (
    <>
      {/* Hero Section */}
      <motion.div
        variants={fadeUpVariant}
        initial="fadeUp"
        whileInView="inView"
        transition={{ duration: 0.5 }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <HeroSection />
      </motion.div>

      {/* MarketingLanding */}
      <motion.div
        variants={fadeUpVariant}
        initial="fadeUp"
        whileInView="inView"
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <MarketingLanding />
      </motion.div>

      {/* Our Services */}
      <motion.div
        variants={fadeUpVariant}
        initial="fadeUp"
        whileInView="inView"
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <OurServices />
      </motion.div>

      {/* Why Us */}
      <motion.div
        variants={fadeUpVariant}
        initial="fadeUp"
        whileInView="inView"
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <WhyUs />
      </motion.div>

      {/* Who We Serve Section */}
      <motion.div
        variants={fadeUpVariant}
        initial="fadeUp"
        whileInView="inView"
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <CustomContainer className="text-center pt-4">
          <SectionHeadingTitle text={aboutPageData.who_we_serve_home.title} />
          <CustomParagraph text={aboutPageData.who_we_serve_home.description} />
          <CardWithImageOrTitle data={aboutPageData.who_we_serve_home.industries} />
        </CustomContainer>
      </motion.div>

      {/* Growth Partner Section */}
      <motion.div
        variants={fadeUpVariant}
        initial="fadeUp"
        whileInView="inView"
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <GrowthPartner />
      </motion.div>
    </>
  );
};

export default HomePage;
